// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xmd2z","col":"styles_col__1DJiX"};